export default __webpack_public_path__ + "static/media/RPG_2.f3a0bfbe.png";